export default class SearchRouteResult {
  /** @param {Object} data
   * @param {RouteResponse} data.routeResponse
   * @param {SearchRouteError} data.error
   */
  constructor({routeResponse, error}) {
    /** @type {RouteResponse} */
    this.routeResponse = routeResponse;
    /** @type {SearchRouteError} */
    this.error = error;
  }
}
